"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 10"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#17181A",
    fillRule: "evenodd",
    d: "M.924 10V.662h4.914c1.778 0 2.688 1.134 2.688 2.38 0 1.176-.728 1.96-1.61 2.142.994.154 1.792 1.12 1.792 2.296 0 1.4-.938 2.52-2.716 2.52H.924zm4.48-5.6c.672 0 1.092-.42 1.092-1.008 0-.588-.42-1.022-1.092-1.022H2.912V4.4h2.492zm.07 3.878c.756 0 1.204-.406 1.204-1.078 0-.588-.42-1.092-1.204-1.092H2.912v2.17h2.562z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBold);
var _default = exports["default"] = Memo;